// TODO: is this meta objct reliable enough? It's pulled from the Shopify Analytics set up
const targetNode = document.getElementById(`RechargeWidget_${meta.product.id}`);

const config = { attributes: true, childList: true, subtree: true };

const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
      for (let node of mutation.addedNodes) {
        // we track only elements, skip other nodes (e.g. text nodes)
        if (!(node instanceof HTMLElement)) continue;

        if (Array.from(node.classList).includes('rc-widget')) {
          if (typeof ProductRefill !== 'undefined') {
            new ProductRefill();
          }

          observer.disconnect();
        }
      }
    }
  }
};

const observer = new MutationObserver(callback);

if (targetNode) {
  observer.observe(targetNode, config);
}

// This file has a lot of overlap with enviroscent-prevent-subscription.js.
// TODO: Consider rebuilding using class inheritance.

class ProductRefill {
  constructor() {
    this.starterKitData = JSON.parse(
      document.querySelector('#starter-kit-data').innerText
    );

    this.refillVariantData = JSON.parse(
      document.querySelector('#refill-variant-data').innerText
    );

    this.subscriptionText = JSON.parse(
      document.querySelector('#subscription-text').innerText
    );

    this.refillPriceLips = document.querySelectorAll('.refill-price-lip');
    this.refillPeriodLips = document.querySelectorAll('.refill-period-lip');

    this.state = {};

    this.init();
  }

  get sellingPlanIndex() {
    if (!this.state.sellingPlan) return 0;

    return this.starterKitData.selling_plan_groups[0].selling_plans.findIndex(
      (plan) => {
        return plan.id == this.state.sellingPlan;
      }
    );
  }

  get refillVariant() {
    const matchingStarterVariant = this.starterKitData.variants.find(
      (variant) => variant.id == this.state.variant
    );

    return this.refillVariantData.find(
      (refill) =>
        refill.title == matchingStarterVariant.title &&
        refill.prevent_subscription != 'true'
    );
  }

  get refillMessage() {
    if (!this.refillVariant) return this.subscriptionText.unavailable;

    const sellingPlanPrice = Shopify.formatMoney(
      this.refillVariant.selling_plan_allocations[this.sellingPlanIndex]
        .checkout_charge_amount
    );

    const sellingPlanName =
      this.refillVariant.selling_plan_allocations[this.sellingPlanIndex].name;

    const concatMessage = this.subscriptionText.price_per_period
      .replace('[price]', sellingPlanPrice)
      .replace('[period]', sellingPlanName);

    return concatMessage;
  }

  init() {
    this.showRefillPrice();
    this.showSubscriptionOption();

    window.Recharge.eventService.listeners[
      `${this.starterKitData.id}:sellingPlan:change`
    ].push(() => {
      this.showRefillPrice();
    });

    window.Recharge.eventService.listeners[
      `${this.starterKitData.id}:variant:change`
    ].push(() => {
      this.showRefillPrice();
    });
  }

  toggleSubscriptionOption() {
    const subscriptionRadio = document.querySelector('.subscription-radio');
    const subscriptionRadioInput = subscriptionRadio.querySelector('input');

    const onetimeRadio = document.querySelector('.onetime-radio');

    if (this.refillVariant) {
      subscriptionRadio.removeAttribute('disabled');
      subscriptionRadioInput.removeAttribute('disabled');
    } else {
      subscriptionRadio.setAttribute('disabled', true);
      subscriptionRadioInput.setAttribute('disabled', true);

      // Select one-time option.
      onetimeRadio.click();
    }
  }

  updateLips() {
    // Don't update the LIPs without a refill product AND a selling plan.
    if (this.refillVariant && this.state.sellingPlan) {
      // TODO: These are redundantly used, clean them up?
      const sellingPlanPrice =
        this.refillVariant.selling_plan_allocations[this.sellingPlanIndex]
          .checkout_charge_amount;

      const sellingPlanName =
        this.refillVariant.selling_plan_allocations[this.sellingPlanIndex].name;

      this.refillPriceLips.forEach((prop) => {
        prop.disabled = false;
        prop.value = sellingPlanPrice;
      });
      this.refillPeriodLips.forEach((prop) => {
        prop.disabled = false;
        prop.value = sellingPlanName;
      });
    } else {
      this.refillPriceLips.forEach((prop) => {
        prop.disabled = true;
        prop.value = '';
      });
      this.refillPeriodLips.forEach((prop) => {
        prop.disabled = true;
        prop.value = '';
      });
    }
  }

  showRefillPrice() {
    this.state = window.Recharge.widgets[this.starterKitData.id].state;

    const refillSmall =
      document.querySelector(
        '.rc-radio.subscription-radio .discount-label small'
      ) ||
      document.querySelector(
        '.rc-radio.subscription-radio .rc-radio__subscription small'
      );

    if (refillSmall) {
      refillSmall.innerText = this.refillMessage;
    } else {
      let small = document.createElement('small');
      small.append(this.refillMessage);

      const rechargeCont =
        document.querySelector(
          '.rc-radio.subscription-radio .discount-label'
        ) ||
        document.querySelector(
          '.rc-radio.subscription-radio .rc-radio__subscription'
        );

      if (rechargeCont) {
        rechargeCont.append(small);
      }
    }

    this.toggleSubscriptionOption();
    this.updateLips();
  }

  showSubscriptionOption() {
    const subRadio = document.querySelector('.rc-radio.subscription-radio');
    subRadio.style.display = 'flex';
  }
}
